// Print categories and individual print data

export interface PrintSize {
  size: string;
  price: number;
}

export interface Print {
  id: string;
  filename: string;
  imagePath: string;
  sizes: PrintSize[];
}

export interface PrintCategory {
  id: string;
  slug: string;
  nameEn: string;
  nameEs: string;
  coverImage: string;
  prints: Print[];
}

// Default sizes for all prints
const defaultSizes: PrintSize[] = [
  { size: 'A4', price: 80 },
  { size: 'A3+', price: 120 }
];

export const printCategories: PrintCategory[] = [
  {
    id: 'entre-olas',
    slug: 'entre-olas',
    nameEn: 'Entre Olas',
    nameEs: 'Entre Olas',
    coverImage: '/images/prints/entre-olas/Entre_Olas_21.jpg',
    prints: [
      {
        id: 'entre-olas-1',
        filename: 'Entre_Olas_1.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_1.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-2',
        filename: 'Entre_Olas_2.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_2.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-3',
        filename: 'Entre_Olas_3.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_3.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-4',
        filename: 'Entre_Olas_4.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_4.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-5',
        filename: 'Entre_Olas_5.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_5.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-9',
        filename: 'Entre_Olas_9.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_9.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-20',
        filename: 'Entre_Olas_20.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_20.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-21',
        filename: 'Entre_Olas_21.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_21.jpg',
        sizes: defaultSizes
      },
      {
        id: 'entre-olas-23',
        filename: 'Entre_Olas_23.jpg',
        imagePath: '/images/prints/entre-olas/Entre_Olas_23.jpg',
        sizes: defaultSizes
      }
    ]
  },
  {
    id: 'gibraltar',
    slug: 'gibraltar',
    nameEn: 'Gibraltar',
    nameEs: 'Gibraltar',
    coverImage: '/images/gibraltar/1.jpg',
    prints: [
      {
        id: 'gibraltar-1',
        filename: '1.jpg',
        imagePath: '/images/gibraltar/1.jpg',
        sizes: defaultSizes
      },
      {
        id: 'gibraltar-2',
        filename: '2.jpg',
        imagePath: '/images/gibraltar/2.jpg',
        sizes: defaultSizes
      },
      {
        id: 'gibraltar-3',
        filename: '3.jpg',
        imagePath: '/images/gibraltar/3.jpg',
        sizes: defaultSizes
      },
      {
        id: 'gibraltar-4',
        filename: '4.jpg',
        imagePath: '/images/gibraltar/4.jpg',
        sizes: defaultSizes
      },
      {
        id: 'gibraltar-5',
        filename: '5.jpg',
        imagePath: '/images/gibraltar/5.jpg',
        sizes: defaultSizes
      }
    ]
  },
  {
    id: 'bolonia',
    slug: 'bolonia',
    nameEn: 'Bolonia',
    nameEs: 'Bolonia',
    coverImage: '/images/bolonia_dunes/07.jpg',
    prints: [
      {
        id: 'bolonia-3',
        filename: '03.jpg',
        imagePath: '/images/bolonia_dunes/03.jpg',
        sizes: defaultSizes
      },
      {
        id: 'bolonia-4',
        filename: '04.jpg',
        imagePath: '/images/bolonia_dunes/04.jpg',
        sizes: defaultSizes
      },
      {
        id: 'bolonia-5',
        filename: '05.jpg',
        imagePath: '/images/bolonia_dunes/05.jpg',
        sizes: defaultSizes
      },
      {
        id: 'bolonia-7',
        filename: '07.jpg',
        imagePath: '/images/bolonia_dunes/07.jpg',
        sizes: defaultSizes
      }
    ]
  }
];

// Helper function to get category by slug
export const getCategoryBySlug = (slug: string): PrintCategory | undefined => {
  return printCategories.find(cat => cat.slug === slug);
};

// Helper function to get category name by language
export const getCategoryName = (category: PrintCategory, language: string): string => {
  return language === 'es' ? category.nameEs : category.nameEn;
};

// Human-readable reference for a print, e.g. "Entre Olas No. 3".
// Used in the UI and in the pre-filled contact email so an enquiry
// identifies the exact photograph without exposing raw filenames.
export const getPrintTitle = (
  category: PrintCategory,
  print: Print,
  language: string
): string => {
  const number = print.filename.replace(/\.[^.]+$/, '').match(/(\d+)$/)?.[1];
  const name = getCategoryName(category, language);
  if (!number) return name;
  return `${name} No. ${parseInt(number, 10)}`;
};
